






































	// @ts-ignore
    import _ from './CEditFrame.ts'; export default _;
